module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/akt-16db11fc776c6c32738dcc58bf64ad2c.png";